<template>
  <v-container>
    <v-layout justify-center>
      <camera v-if="isCameraVisible"></camera>
      <address-details v-else></address-details>
    </v-layout>
  </v-container>
</template>
<script>
import AddressDetails from "@/components/AddressDetails";
import Camera from "@/components/Camera";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "Address",
  components: {
    AddressDetails,
    Camera
  },
  computed: {
    ...mapGetters(["activeAddress", "isCameraVisible"])
  },
  methods: {
    ...mapActions(["openCamera", "closeCamera"])
  }
};
</script>

